import {
  cancellationDisclaimerMessage,
  transactionDisclaimerMessage,
  GO_BACK_TO_HOLDINGS,
  BACK_TO_TRANSACTIONS,
  CONGRATULATIONS,
  TRANSACTION_SUCCESS_MESSAGE,
  SUCCESS,
  SUCCESSFUL,
  REDEEM_SUCCESS_MESSAGE,
  SWITCH_SUCCESS_MESSAGE,
  SIP_CANCEL_SUCCESS_MESSAGE,
  STP_CANCEL_SUCCESS_MESSAGE,
  TRANSACTION_TYPE,
  TRANSACTION_SOURCE,
  EXPLORE_OTHER_FUNDS,
  MUTUAL_FUND_HOME,
  SWP_CANCEL_SUCCESS_MESSAGE,
  SWP_SUCCESS_MESSAGE,
  STP_SUCCESS_MESSAGE,
  SIPtransactionDisclaimerMessage,
} from '../../../constants/TransactionSuccessConstants';
import RedeemSuccessIcon from '../../../assets/icons/redeem-success.svg';
import SIPSuccessIcon from '../../../assets/icons/sip-success.svg';
import SwitchSuccessIcon from '../../../assets/icons/switch-success.svg';
import { routes } from '../../../config/routes';

// Get Icon for the successful transaction page
export const getSuccessfulTransactionIcon = (transactionType: string) => {
  switch (transactionType) {
    case TRANSACTION_TYPE.INVEST:
    case TRANSACTION_TYPE.REDEEM:
    case TRANSACTION_TYPE.STP:
      return <RedeemSuccessIcon />;
    case TRANSACTION_TYPE.SIP:
      return <SIPSuccessIcon />;
    case TRANSACTION_TYPE.SWITCH:
    case TRANSACTION_TYPE.SWP:
      return <SwitchSuccessIcon />;
    default:
      return <RedeemSuccessIcon />;
  }
};

// Get succes message to show on the success page(can be SUCCESS, CONGRATULATIONS, etc)
export const getSuccessfulMessage = (transactionType: string) => {
  switch (transactionType) {
    case TRANSACTION_TYPE.INVEST:
      return SUCCESSFUL;
    case TRANSACTION_TYPE.REDEEM:
    case TRANSACTION_TYPE.SWITCH:
      return SUCCESS;
    case TRANSACTION_TYPE.SIP || TRANSACTION_TYPE.STP:
      return SUCCESSFUL;
    default:
      return CONGRATULATIONS;
  }
};

// Detailed successs message description
export const getSuccessMessageDescription = (transactionType: string, subTransactionType: string | undefined) => {
  switch (transactionType) {
    case TRANSACTION_TYPE.INVEST:
    case TRANSACTION_TYPE.SIP:
      return TRANSACTION_SUCCESS_MESSAGE;
    case TRANSACTION_TYPE.REDEEM:
      if (subTransactionType === TRANSACTION_TYPE.SWP) {
        return SWP_SUCCESS_MESSAGE;
      } else {
        return REDEEM_SUCCESS_MESSAGE;
      }
    case TRANSACTION_TYPE.SWITCH:
      if (subTransactionType === TRANSACTION_TYPE.STP) {
        return STP_SUCCESS_MESSAGE;
      } else {
        return SWITCH_SUCCESS_MESSAGE;
      }
    case TRANSACTION_TYPE.STP_CANCEL:
      return STP_CANCEL_SUCCESS_MESSAGE;
    case TRANSACTION_TYPE.SIP_CANCEL:
      return SIP_CANCEL_SUCCESS_MESSAGE;
    case TRANSACTION_TYPE.SWP_CANCEL:
      return SWP_CANCEL_SUCCESS_MESSAGE;
    default:
      return TRANSACTION_SUCCESS_MESSAGE;
  }
};

// Get the disclaimer message to show on the footer
export const getSucessfulTransactionDisclaimerMessage = (transactionType: string) => {
  switch (transactionType) {
    case TRANSACTION_TYPE.INVEST:
    case TRANSACTION_TYPE.REDEEM:
    case TRANSACTION_TYPE.SWITCH:
      return transactionDisclaimerMessage;
    case TRANSACTION_TYPE.SIP:
      return SIPtransactionDisclaimerMessage;
    case TRANSACTION_TYPE.STP_CANCEL:
    case TRANSACTION_TYPE.SIP_CANCEL:
    case TRANSACTION_TYPE.SWP_CANCEL:
      return cancellationDisclaimerMessage;
    default:
      return transactionDisclaimerMessage;
  }
};

// Return the go back message based on the source page called from
export const getTransactionGoBackMessage = (transactionSource: string) => {
  switch (transactionSource) {
    case TRANSACTION_SOURCE.HOLDINGS:
      return GO_BACK_TO_HOLDINGS;
    case TRANSACTION_SOURCE.TRANSACTION:
      return BACK_TO_TRANSACTIONS;
    case TRANSACTION_SOURCE.MUTUAL_FUND:
      return MUTUAL_FUND_HOME;
    case TRANSACTION_SOURCE.EXPLORE:
      return EXPLORE_OTHER_FUNDS;
    default:
      return BACK_TO_TRANSACTIONS;
  }
};

// Get the URL to navigate to the previous page based on the transactionSource
export const getTransactionGoBackUrl = (transactionSource: string) => {
  switch (transactionSource) {
    case TRANSACTION_SOURCE.HOLDINGS:
      return routes.HOLDINGS;
    case TRANSACTION_SOURCE.TRANSACTION:
      return routes.TRANSACTION;
    case TRANSACTION_SOURCE.MUTUAL_FUND:
      return routes.MUTUAL_FUND;
    case TRANSACTION_SOURCE.EXPLORE:
      return routes.EXPLORE;
    default:
      return routes.EXPLORE;
  }
};

export const shouldShowSeparatorTransactionPage = (transactionType: string) => {
  switch (transactionType) {
    case TRANSACTION_TYPE.INVEST:
    case TRANSACTION_TYPE.SIP:
      return false;
    case TRANSACTION_TYPE.REDEEM:
    case TRANSACTION_TYPE.SWITCH:
    case TRANSACTION_TYPE.STP:
      return true;
    default:
      return false;
  }
};

export const isCancellationPageSuccessfulTransaction = (transactionType: string) => {
  switch (transactionType) {
    case TRANSACTION_TYPE.STP:
      return true;
    case TRANSACTION_TYPE.REDEEM:
    case TRANSACTION_TYPE.SWITCH:
    case TRANSACTION_TYPE.INVEST:
    case TRANSACTION_TYPE.SIP:
      return false;
    default:
      return false;
  }
};

export const getTransactionTypeMessage = (subTransactionType: string) => {
  switch (subTransactionType) {
    case TRANSACTION_TYPE.FULL_REDEMPTION:
      return 'Full Redemption Plan';
    case TRANSACTION_TYPE.PARTIAL_REDEMPTION:
      return 'Partial Redemption Plan';
    case TRANSACTION_TYPE.SWP:
      return 'Systematic Withdrawal Plan';
    case TRANSACTION_TYPE.STP:
      return 'Systematic Transfer Plan';
    case TRANSACTION_TYPE.FULL_SWITCH:
      return 'Full Switch Plan';
    case TRANSACTION_TYPE.PARTIAL_SWITCH:
      return 'Partial Switch Plan';
    default:
      return 'Lumpsum';
  }
};

export const getInstallmentTitle = (transactionType: string) => {
  switch (transactionType) {
    case TRANSACTION_TYPE.REDEEM:
      return 'No. of withdrawals';
    case TRANSACTION_TYPE.SWITCH:
      return 'No. of transfers';
    default:
      return "No. of SIPs";
  }
};

export const getSipScheduleTitle = (isNfo: boolean) => {
  if (isNfo) {
    return 'SIP Schedule (Post NFO Allotment)';
  } else {
    return 'SIP Schedule';
  }
};
